import { ISimilarityMatch } from 'APIPackage/SimilarityModule/interfaces/ISimilarityMatch';
import { ROUTE_KNM_LIST_WITH_PLAN } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

export function SimilaritiesByPersonPlanIdCell({ row }: ITableRenderCell<ISimilarityMatch>) {
  return (
    <a
      className="shared-table-link"
      href={ROUTE_KNM_LIST_WITH_PLAN(row.planId)}
      target="_blank"
      rel="noopener noreferrer"
    >
      {row.planId}
    </a>
  );
}
